<template>
    <div class="card">
        <div class="subtitle middle-sidebar-title is-5 has-text-weight-bold">
            <i @click="$emit('close')"
               class="icon fas fa-times close has-text-grey pointer"></i> &nbsp;

            <span>{{card.note.name || 'Untitled note'}} &nbsp; </span>
        </div> <br/>

        <card-details-assignees
            :in_note_editor="in_note_editor"
            :column="column"
            :space="space"
            :card="card"/><br/>

        <b>Milestone &nbsp;</b><br/><br/>

        <multiselect
            v-model="milestone"
            :loading="milestones.loading"
            :options="milestones.data.results || []"
            :internal-search="false"
            @search-change="search_milestones"
            @input="save_milestone"
            placeholder="Search milestone to add"
            name="milestone"
            track-by="id"
            label="name"/><br/>

        <b>Due date</b> <br/><br/>

        <datepicker
            calendar-class="calendar-class"
            input-class="input"
            wrapper-class="wrapper-class"
            placeholder="Select due date"
            name="due_date"
            class="datepicker"
            v-model="due_date"
            @input="save_due"
            :clearButton="true"/> <br/>

        <card-details-tags
            :in_note_editor="in_note_editor"
            :column="column"
            :space="space"
            :card="card"/><br/>

        <base-button
            v-if="!in_note_editor"
            @click="show_confirm = true"
            :loading="remove.loading"
            icon="fas fa-trash-alt"
            text="Remove Card"
            class="is-block"/>

        <base-confirm-modal
            v-if="show_confirm"
            text="Do you really want to remove this Card?"
            @close="show_confirm = false"
            @ok="remove_card"/>
    </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
import Multiselect from 'vue-multiselect';
import Datepicker from 'vuejs-datepicker';
import CardDetailsTags from './CardDetailsTags.vue';
import CardDetailsAssignees from './CardDetailsAssignees.vue';

export default {
    components: {
        CardDetailsTags, CardDetailsAssignees, Datepicker, Multiselect,
    },
    props: ['space', 'column', 'card', 'in_note_editor'],
    computed: {
        ...mapState('cards', ['remove', 'update']),
        ...mapState('milestones', { milestones: 'list' }),
    },
    data() {
        return { show_confirm: false, due_date: null, milestone: null };
    },
    mounted() {
        if (!this.milestones.data.results || this.milestones.data.results.length === 0) {
            this.$store.dispatch('milestones/list', { space_id: this.space.id });
        }
    },
    watch: {
        card: {
            immediate: true,
            handler(card) {
                this.due_date = card.due_date;
                this.milestone = card.milestone;
            },
        },
    },
    methods: {
        async remove_card() {
            this.show_confirm = false;

            await this.$store.dispatch('cards/remove', {
                flow_id: this.card.flow.id,
                space_id: this.space.id,
                card_id: this.card.id,
            });

            this.$emit('removed');
        },
        save_due() {
            const due_date = this.due_date ? moment(this.due_date).format('YYYY-MM-DD') : null;

            this.$store.dispatch('cards/update', {
                space_id: this.space.id,
                flow_id: this.card.flow.id,
                card_id: this.card.id,
                data: { due_date },
            });

            if (!this.in_note_editor) {
                this.$store.commit('cards/update_due', {
                    column_id: this.column,
                    card_id: this.card.id,
                    due_date,
                });
            }
        },
        search_milestones(search) {
            if (search) {
                this.$store.dispatch('milestones/list', { space_id: this.space.id, search });
            }
        },
        async save_milestone() {
            await this.$store.dispatch('cards/update', {
                space_id: this.space.id,
                flow_id: this.card.flow.id,
                card_id: this.card.id,
                data: { milestone: this.milestone.id },
            });
        },
    },
};
</script>

<style scoped>
    .card { width: 25rem; }

    .datepicker >>> .vdp-datepicker__clear-button {
        position: absolute;
        right: 0.6rem;
        top: 0;
        font-size: 1.4em;
    }
</style>
